"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Tue Sep 25 2018
 */

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * CompetitorProductBindDTOConverter
 *
 * @author RV
 */


var CompetitorProductBindDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(CompetitorProductBindDTOConverter, _DataObjectConverter_);

  function CompetitorProductBindDTOConverter() {
    _classCallCheck(this, CompetitorProductBindDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorProductBindDTOConverter).apply(this, arguments));
  }

  return CompetitorProductBindDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.CompetitorProductBindDTOConverter = CompetitorProductBindDTOConverter;